import i18next from 'i18next';
import axios from 'axios';
import config from '@wearetla/tla-essentials-tools/config';
import translations from '/data/translations';

const instanceCache = new Map();

const createI18nInstance = (language) => {
	const fallbackLanguage = config.i18n?.defaultLanguage;
	const lng = language || axios.defaults.headers.common?.language || fallbackLanguage;

	if (instanceCache.has(lng)) {
		return instanceCache.get(lng);
	}

	const instance = i18next.createInstance();

	instance.init({
		lng,
		fallbackLng: fallbackLanguage,
		keySeparator: false,
		nsSeparator: false,
		resources: {
			en: { translation: translations.en ?? {} },
		},
		interpolation: {
			escapeValue: false,
		},
	});

	instanceCache.set(lng, instance);
	return instance;
};

export default createI18nInstance;
